import {Recipient} from './recipient';
import {Upload} from './upload';

export enum DocumentStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum DocumentType {
  ID = 'id',
  ADDRESS = 'address',
  SELFIE = 'selfie',
  BANK_ACCOUNT = 'bank_account',
  BUSINESS_CONTRACT = 'business_contract',
  BUSINESS_PLAN = 'business_plan',
  DRIVERS_LICENSE = 'drivers_license',
  PASSPORT = 'passport',
  UTILITY_BILL = 'utility_bill',
  OTHER = 'other',
}

export type DocumentRequirements = {[K in DocumentType]?: boolean};

export interface RecipientDocument {
  id: number;
  type: DocumentType;
  upload?: Upload | null;
  status: DocumentStatus;
  rejectionReason?: string | null;
  recipient: Recipient;
  createdAt: Date;
  updatedAt: Date;
  fileUrl: string;
}
